<script setup>
/**
 * The root Vue application of Sign Only Service.
 *
 * @author Documill, 2024
 */
import Header from '../src/views/components/Header';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import {useRoute} from 'vue-router';
import { computed,onMounted,onUnmounted,watch } from 'vue';
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n";
import { applyCustomBrand } from 'documill-ui-library';

const store = useStore();
const route = useRoute();
// Import minified or non-minified UIKit CSS depending on whether we're in production or development mode
//require(UIKIT_CSS);

UIkit.use(Icons);

//Make below imports global
window.UIkit = UIkit; // UIKit
document.title="Documill";

const { locale } = useI18n();

const showDocumillHeader = computed(() => {
  return !(route.name == null || // SOFLOW-152
    route.name == "viewComments" ||
    route.name== 'draft' ||
    route.name == 'document' ||
    route.name == 'sign' ||
    route.name == 'signGuest' ||
    (route.name == '404' && !store.getters.isAuthenticated) ||
    (route.name == '404' && store.getters.isAuthenticated && store.getters.getUserRole === "GUEST") ||
    route.name == 'completedTaskGuest' ||
    route.name == 'signConfiguration');
});

function storeWindowDimensions() {
  store.commit("setWindowWidth", window.innerWidth);
  store.commit("setWindowHeight", window.innerHeight);
}

onMounted(() => {
  storeWindowDimensions();
  window.addEventListener('resize', storeWindowDimensions);
});

onUnmounted(() => {
  window.removeEventListener('resize', storeWindowDimensions);
});

watch(() => store.getters.getUserLocale, function() {
  locale.value = store.getters.getUserLocale;
});

watch(() => store.getters.getOrganizationBrand, applyCustomBrand, { immediate: true });

</script>

<template>
  <div>
    <Header v-if="showDocumillHeader" />
    <div id="documill-main-section" :uk-height-viewport="route.name == 'sign' ? 'expand: false' : 'expand: true'">
      <router-view/>
    </div>
  </div>
</template>

<style>
#documill-main-section{
  display:flex;
  justify-content: center;
  overflow:hidden;
}

@import "../node_modules/uikit/dist/css/uikit.css";
@import "./sign_only.css";
@import "documill-ui-library/style.css";
</style>
